/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

// Import jQuery and Slick Carousel from node_modules
import $ from 'jquery';
import 'slick-carousel';

// Ensure jQuery is available globally (required by Slick)
window.jQuery = window.$ = $;

document.addEventListener('DOMContentLoaded', () => {

    // Function to check and add background-red class
    function addBackgroundClass(element) {
        // Get the inline background color (returns rgb, rgba, or hex)
        const bgColor = element.style.backgroundColor;

        // Check if background color matches #F3FBF8
        if (bgColor === 'rgb(243, 251, 248)') {
            element.classList.add('background-green');
        }
        

        // Check if background color matches #f3dbdc
        if (bgColor === 'rgb(243, 219, 220)') {
            element.classList.add('background-red');
        }

        // Check if background color matches #FFF8F0
        if (bgColor === 'rgb(255, 248, 240)') {
            element.classList.add('background-yellow');
        }
    }

    // Target all elements with .has-background (e.g., group blocks)
    const groupBlocks = document.querySelectorAll('.has-background');
    groupBlocks.forEach(block => addBackgroundClass(block));

    // Debounce function to limit how often a function is called
    function debounce(func, wait) {
        let timeout;
        return function() {
            const context = this, args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                func.apply(context, args);
            }, wait);
        };
    }
    // Find all carousel instances
    const carousels = document.querySelectorAll('.wp-block-showstopper-featured-categories-carousel');
    carousels.forEach((carousel) => {
        // Initialize Slick Carousel
        $(carousel).slick({
            slidesToShow: 5,      // Default: 1 item per view
            slidesToScroll: 1,    // Scroll one slide at a time
            infinite: true,       // Loop if more than 1 item
            variableWidth: false,
            centerMode: false,
            arrows: true,        // We'll add custom buttons
            dots: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                },
            ]
        });

        // Equalize slide heights to widths (want to 1:1 square)
        function equalizeSlideHeights() {
            const slides = carousel.querySelectorAll('.slick-slide');
            const categoryBlocks = carousel.querySelectorAll('.wc-block-featured-category');
            const oneParent = categoryBlocks[0].parentNode;
            const parentStyles = window.getComputedStyle(oneParent);
            const paddingInlineStart = parseFloat(parentStyles.getPropertyValue('padding-inline-start'));
            let width = slides[0].offsetWidth - (2 * paddingInlineStart);

            // Reset heights to auto to measure natural height
            categoryBlocks.forEach(slide => {
                slide.style.minHeight = `${width}px`;
            }); 

            slides.forEach(slide => {
                slide.style.height = `${width}px`;
            });
        }

        // Run on load and after slide change
        equalizeSlideHeights();
        $(carousel).on('afterChange', equalizeSlideHeights);

        // Add debounced resize event listener
        const debouncedEqualize = debounce(equalizeSlideHeights, 250);
        window.addEventListener('resize', debouncedEqualize);
        
        // Clean up event listener when carousel is destroyed (if needed)
        $(carousel).on('destroy', () => {
            window.removeEventListener('resize', debouncedEqualize);
        });
    });
});
